<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách hợp đồng Merchant cộng tác viên</h1>
      <div class="btn-group float-right">
        <button class="f12 font-medium btn btn-outline-secondary" @click="assignMC">Gán MC</button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
              v-model="search.textSearch"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian"
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em" class="text-center pt-1">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Cộng tác viên"
              v-model="search.agentId"
              :options="dataCTV"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Vùng kinh doanh"
              v-model="search.regionId"
              :options="dataRegion"
              @change="queryProvince($event)"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Tỉnh/Thành phố"
              v-model="search.cityCode"
              :options="dataProvince"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Nhóm dịch vụ"
              v-model="search.servicePackCode"
              :options="groupService"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Trạng thái"
              v-model="search.status"
              :options="dataStatus"
            ></Select2>
          </div>

          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              type="button"
              class="btn btn-primary hc-37 mr-2 pt-2"
              v-if="selected.length > 0"
              @click="bonusReceive"
            >
              Xác nhận chi
            </button>
            <button
              type="button"
              class="btn btn-primary hc-37 mr-2 pt-2"
              v-if="selected.length > 0"
              @click="rejectReceive(null)"
            >
              Từ chối chi
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="box-header mb-1">
            Tổng số :<strong class="text-primary">{{ pagination.total }}</strong>
          </div>
          <div class="table-responsive">
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th width="50">
                    <div class="checkbox text-center">
                      <input type="checkbox" v-model="selectAll" v-if="selected.length > 0" />
                    </div>
                  </th>
                  <th scope="col">Merchant</th>
                  <th scope="col">Nhóm dịch vụ</th>
                  <th scope="col">Dịch vụ</th>
                  <th scope="col">Hoa hồng</th>
                  <th scope="col">Cộng tác viên</th>
                  <th scope="col">Sales chăm sóc</th>
                  <th scope="col" class="text-right">Trạng thái</th>
                  <th scope="col" class="text-right">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="(item, index) in dataMC" :key="index">
                  <td>
                    <input
                      type="checkbox"
                      v-model="selected"
                      :value="item"
                      number
                      :disabled="item.status !== 'WAIT_RECEIVE'"
                    />
                  </td>
                  <td>
                    <b>{{ item.merchantName }}</b
                    ><br />
                    <a href="#">{{ item.mobile }}</a
                    ><br />
                    <a href="#">{{ item.email }}</a
                    ><br />
                    {{ item.district }}, {{ item.city }}
                  </td>
                  <td>{{ item.service_name }}</td>
                  <td>
                    <div v-for="(itemn, indexn) in item.listServiceType" :key="indexn">
                      {{ itemn.serviceType }}
                    </div>
                  </td>
                  <td>{{ item.bonusMoney }}</td>
                  <td>
                    <b>{{ item.agentName }}</b
                    ><br />
                    <a href="tel:">{{ item.agentMobile }}</a> <br />
                  </td>
                  <td>
                    <b>{{ item.activeSaleName }}</b
                    ><br />
                    <a href="mailto:">{{ item.activeSaleEmail }}</a
                    ><br />
                  </td>
                  <td class="text-center">
                    <span class="badge badge-secondary" v-if="item.status === 'NEW'">Mới tạo</span>
                    <span class="badge badge-info" v-if="item.status === 'ADVISING'"
                      >Đang tư vấn</span
                    >
                    <span class="badge badge-primary" v-if="item.status === 'WAIT_RECEIVE'"
                      >Chờ nhận</span
                    >
                    <span class="badge badge-success" v-if="item.status === 'DONE_RECEIVE'"
                      >Đã nhận</span
                    >
                    <span class="badge badge-warning" v-if="item.status === 'REJECT'">Từ chối</span>
                    <span class="badge badge-danger" v-if="item.status === 'FAIL'">Thất bại</span>
                  </td>
                  <td class="text-right">
                    <div class="dropdown show float-right">
                      <button
                        type="button"
                        class="btn btn-outline-light btn-sm dropdown-toggle ml-1"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="sr-only">More</span>
                      </button>
                      <div class="dropdown-menu">
                        <button
                          v-if="item.status === 'WAIT_RECEIVE'"
                          @click="bonusReceiveById(item)"
                          class="dropdown-item"
                          data-toggle="modal"
                        >
                          <i class="bx bx-check"></i> Xác nhận chi
                        </button>
                        <button
                          v-if="item.status === 'WAIT_RECEIVE'"
                          @click="rejectReceive(item.cstmAgencyId)"
                          class="dropdown-item"
                          data-toggle="modal"
                        >
                          <i class="bx bx-check"></i> Từ chối chi
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
    <!-- Modal xác nhận chi-->
    <b-modal v-model="bonusReceiveModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="modal-body text-center">
        <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
        <h2 class="f18 py-3">Bạn có chắc chắn xác nhận chi không?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="bonusReceiveConfirm"> Đồng ý </b-button>
      </template>
    </b-modal>
    <!-- Modal thông báo chọn mc ở trạng thái chờ nhận-->
    <b-modal id="modal-scoped" v-model="selectWaitReceiveModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="modal-body text-center">
        <img src="@/assets/img/noti-fail2.svg" alt="icon-successs" />
        <h2 class="f18 py-3">Vui lòng chọn những MC ở trạng thái chờ nhận</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <!-- Modal từ chối chi-->
    <b-modal v-model="rejectReceiveModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="modal-body text-center">
        <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
        <h2 class="f18 py-3">Bạn có chắc chắn từ chối chi không?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="toRejectReason"> Đồng ý </b-button>
      </template>
    </b-modal>
    <!-- Modal lý do từ chối chi-->
    <b-modal id="modal-scoped" v-model="rejectResonModal" @hidden="cstmAgencyId = null">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>

      <textarea v-model="textReason" class="form-control" :maxlength="225" rows="3"></textarea>

      <template #modal-footer="{}">
        <b-button
          v-if="cstmAgencyId === null"
          size="sm"
          variant="light"
          @click="rejectReceiveConfirm"
        >
          Xác nhận
        </b-button>
        <b-button v-else size="sm" variant="light" @click="rejectReceiveById"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img src="@/assets/img/noti-success2.svg" alt="icon-successs" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'
  import { StaffService } from '@/services/staff.service'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'

  export default {
    mixins: [prepareQueryParamsMixin],
    components: {
      DateRangePicker,
    },
    data() {
      return {
        dataMC: [],
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dataRegion: [],
        dataProvince: [],
        dataCTV: [],
        dataStatus: [
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'ADVISING', text: 'Đang tư vấn' },
          { id: 'WAIT_RECEIVE', text: 'Chờ nhận' },
          { id: 'DONE_RECEIVE', text: 'Đã nhận' },
          { id: 'REJECT', text: 'Từ chối' },
          { id: 'FAIL', text: 'Thất bại' },
        ],
        groupService: [],
        groupServiceKey: {},
        loading: true,
        search: {
          limit: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        selected: [],
        selectBonus: [],
        bonusReceiveModal: false,
        rejectReceiveModal: false,
        rejectResonModal: false,
        textReason: '',
        selectWaitReceiveModal: false,
        notiModal: false,
        msgNoti: '',
        cstmAgencyId: null,
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    filters: {
      formatDatePicker(date) {
        if (!date) return
        return moment(date).format('DD/MM/YYYY')
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataMC ? this.selected.length === this.dataMC.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataMC.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
    },
    mounted() {
      this.fetchData()
      this.getServiceList()
      this.listAgent()
      this.getRegions()
    },
    methods: {
      transfromDate() {
        this.search.startDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      // chuyển trang Gán MC
      assignMC() {
        this.$router.push('/assign-mc')
      },
      // chuyển màn chi tiết
      mcDetail(item) {
        this.$router.push({ path: `/manage-mc/${item.customerId}` })
      },
      // check stt chờ nhận
      checkStatus() {
        const data = []
        this.selected.forEach(el => {
          if (el.status !== 'WAIT_RECEIVE') {
            this.selectWaitReceiveModal = true
          } else {
            data.push(el.cstmAgencyId)
          }
        })
        return data
      },
      // xác nhận chi
      bonusReceive() {
        this.bonusReceiveModal = true
        return false
      },
      // confirm chi
      async bonusReceiveConfirm() {
        this.selectWaitReceiveModal = false
        this.bonusReceiveModal = false
        const _selectedBonus = this.checkStatus()
        try {
          const data = await AgentService.bonusReceivedConfirm({
            agencyCstmIdList: _selectedBonus,
          })
          if (data.success) {
            this.notiModal = true
            this.msgNoti = 'Xác nhận chi thành công'
            this.fetchData()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // xác nhận chi 1 mc
      async bonusReceiveById(item) {
        try {
          const data = await AgentService.bonusReceivedConfirm({
            agencyCstmIdList: [item.cstmAgencyId],
          })
          if (data.success) {
            this.notiModal = true
            this.msgNoti = 'Xác nhận chi thành công'
            this.fetchData()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // từ chối chi
      rejectReceive(cstmAgencyId) {
        this.rejectReceiveModal = true
        this.cstmAgencyId = cstmAgencyId ?? null
      },
      // lý do từ chối
      toRejectReason() {
        this.rejectReceiveModal = false
        this.rejectResonModal = true
        return false
      },
      // confirm từ chối chi
      async rejectReceiveConfirm() {
        this.selectWaitReceiveModal = false
        const _selectedBonus = this.checkStatus()
        try {
          const data = await AgentService.rejectReceivedConfirm({
            agencyCstmIdList: _selectedBonus,
            reason: this.textReason,
          })
          if (data.success) {
            this.notiModal = true
            this.msgNoti = 'Xác nhận từ chối chi thành công'
            this.fetchData()
            this.textReason = ''
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
          this.rejectResonModal = false
        }
      },
      // từ chối chi 1 mc
      async rejectReceiveById() {
        try {
          this.rejectResonModal = true
          const data = await AgentService.rejectReceivedConfirm({
            agencyCstmIdList: [this.cstmAgencyId],
            reason: this.textReason,
          })
          if (data.success) {
            this.notiModal = true
            this.msgNoti = 'Từ chối chi thành công'
            this.fetchData()
            this.textReason = ''
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
          this.rejectResonModal = false
        }
      },
      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      async removeForm() {
        this.dateRange.startDate = null
        this.dateRange.endDate = null
        this.search = {
          limit: 50,
          page: 1,
        }
        await this.fetchData()
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataRegion = data.data.map(e => {
            return { id: e.id, text: e.name }
          })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return { id: e.code, text: e.name }
            })
          }
        } catch (error) {}
      },
      // ds nhóm dịch vụ
      async getServiceList() {
        this.loading = true
        try {
          const data = await AgentService.getServiceList()
          if (data.success) {
            data.data.groupService.map(e => {
              this.groupService.push({ id: e.service, text: e.name })
              this.groupServiceKey[e.service] = e.name
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // danh sách CTV
      async listAgent() {
        this.loading = true
        try {
          const data = await AgentService.listAgentForSearch()
          if (data.success) {
            data.data.map(e => {
              this.dataCTV.push({ id: e.agentId, text: e.name })
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // dữ liệu bảng
      async fetchData() {
        this.loading = true
        try {
          const data = await AgentService.agencyListMC(this.search)
          if (data.success) {
            this.dataMC = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
            data.data.map((e, index) => {
              if (this.groupServiceKey[e.servicePackCode]) {
                this.dataMC[index].service_name = this.groupServiceKey[e.servicePackCode]
              }
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
